<template>
  <div class="standalone-page">
    <SiteHeader :config="config" :query-string="queryString" />
    <main>
      <router-link :to="{ path: '/', query: $route.query }">{{ $t('backHome') }}</router-link>
      <h1>{{ $t('standaloneGames') }} · Android</h1>
      <p v-if="loading" role="status">{{ $t('loading') }}</p>
      <div v-else-if="failed" role="alert"><p>{{ $t('loadError') }}</p><button type="button" @click="load">{{ $t('retry') }}</button></div>
      <p v-else-if="!games.length">{{ $t('noAndroidGames') }}</p>
      <div v-else class="standalone-grid">
        <div v-for="game in games" :key="game.id">
          <GameCard :game="game" image-url="" :query-string="queryString" />
          <p>{{ game.name }}</p>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { configurationLocale, androidGames, officialLink, standaloneImageUrl } from '@/utils/navigation'
import axios from 'axios'
import SiteHeader from '@/components/SiteHeader.vue'
import GameCard from '@/components/game-card-mobile.vue'
import { getCloudStorage } from '@/plugin/axios'


export default {
  name: 'StandaloneGamesPage',
  components: { SiteHeader, GameCard },
  data() { return { config: {}, items: [], loading: true, failed: false, configReady: false, requestId: 0, queryString: window.location.search.slice(1) } },
  computed: {
    games() {
      return androidGames(this.items).map(game => ({
        id: game.id,
        serviceId: game.serviceId,
        supportEnglish: game.lang === 'en-US',
        name: game.title,
        image: standaloneImageUrl(game.thumbnail, process.env.VUE_APP_IMAGE_RESIZE_URL || 'https://imgdl.h365.games'),
        link: officialLink(this.config.logoURL, this.$i18n.locale, '', `/standaloneGame/detail/${game.id}`)
      }))
    }
  },
  watch: { '$i18n.locale'() { if (this.configReady) this.loadGames() } },
  created() { this.load() },
  beforeDestroy() { this.requestId++ },
  methods: {
    async load() {
      this.loading = true
      this.failed = false
      this.configReady = false
      try {
        const source = new URLSearchParams(this.queryString).get('utm_source') || 'default'
        const params = { alt: 'media', t: Math.floor(Date.now() / 300000) }
        let response
        try {
          response = await getCloudStorage.get(encodeURIComponent(`config/minisite/${source}.json`), { params })
        }
        catch (_) {
          response = await getCloudStorage.get(encodeURIComponent('config/minisite/default.json'), { params })
        }
        this.config = response.data
        if (!this.config.logoURL) throw new Error('Missing official site URL')
        if (this.$i18n.messages[configurationLocale(this.config.lang)]) this.$i18n.locale = configurationLocale(this.config.lang)
        await this.$nextTick()
        this.configReady = true
        await this.loadGames()
      }
      catch (_) {
        this.failed = true
        this.loading = false
      }
    },
    async loadGames() {
      const locale = this.$i18n.locale
      const requestId = ++this.requestId
      this.loading = true
      this.failed = false
      try {
        const base = process.env.VUE_APP_PLAYER_PORTAL_API_URL || 'https://www-api.h365.games/api/v1/'
        const { data } = await axios.get(`${base.replace(/\/$/, '')}/standaloneGame/H365/list`, { params: { lang: locale, limit: 500 }, timeout: 15000 })
        const items = data?.data?.result || data?.data
        if (!Array.isArray(items)) throw new Error('Invalid game list')
        if (requestId === this.requestId) this.items = items
      }
      catch (_) {
        if (requestId === this.requestId) this.failed = true
      }
      finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.standalone-page { min-height: 100vh; color: #f5f5f1; background: #1c1c1c; }
main { max-width: 1000px; padding: 76px 15px 24px; margin: 0 auto; }
main > a { color: #f5c400; }
h1 { font-size: 24px; margin: 20px 0; }
.standalone-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px 15px; }
.standalone-grid p { font-size: 13px; margin-top: 8px; overflow-wrap: anywhere; }
button { background: #f5c400; color: #111210; border: 0; border-radius: 4px; padding: 10px 16px; cursor: pointer; }
</style>